export default function RightArrow({
                                    width = '24',
                                    height = '24',
                                    opacity,
                                    cursor,
                                    onClick,
                                    stroke = '#393939',
                                  }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
      width={width}
      height={height}
      opacity={opacity}
      cursor={cursor}
      onClick={onClick}
    >
      <path d="M9 18L15 12L9 6" stroke="#393939" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}